const CHUNK_SIZE = 0x8000 // 32 KiB – stays well below call-stack limits

/**
 * Converts an ArrayBuffer to a base64-encoded string using chunked processing.
 * Avoids the quadratic string growth that occurs when concatenating
 * individual characters, and prevents "Invalid string length" errors on
 * large buffers.
 */
export const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer)
  const chunks: string[] = []
  for (let i = 0; i < bytes.length; i += CHUNK_SIZE) {
    chunks.push(
      String.fromCharCode.apply(
        null,
        Array.from(bytes.subarray(i, i + CHUNK_SIZE)),
      ),
    )
  }
  return btoa(chunks.join(''))
}
